import { render } from "./onboarding_compliance_component.html?vue&type=template&id=046966c2&scoped=true&external"
import script from "./onboarding_compliance_component.js?vue&type=script&lang=js&external"
export * from "./onboarding_compliance_component.js?vue&type=script&lang=js&external"

import "./OnboardingComplianceComponent.vue?vue&type=style&index=0&id=046966c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046966c2"]])

export default __exports__